import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import classNames from "classnames";

const mapState = (state) => {
	return {
		conectaMovil: state.global.conectaMovil,
		ramo: state.registro.ramo,
		grupo: state.registro.configuracion.grupo,
		initialValues: {
			email: state.registro.email,
			email_confirm: state.registro.email,
			fecha_nacimiento: state.registro.fechaNacimiento,
			fecha_nacimiento_date: state.registro.fechaNacimientoDate,
			lada_fijo: state.registro.ladaFijo,
			telefono_fijo: state.registro.telFijo,
			lada_movil: state.registro.ladaCelular,
			telefono_movil: state.registro.telCelular,
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres
		}
	};
};

const hideErrors = {};
const telefono = tipo => (value, campos) => {
	let numero = (value != undefined)? value.replace("+","").replace(" ","") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";
	//campos[tipo] = (numero == "" || isNaN(numero))? "" : prefijo + numero;

	if(numero != "" && isNaN(numero)) {
		let _temp = "";
		for(let i = 0; i < numero.length; i++) {
			if(!isNaN(numero.substr(i,1))) {
				_temp  +=  numero.substr(i,1);
			}
		}
		numero = _temp;
	}

	if(numero != "") {
		campos[tipo] = prefijo + ((/lada/g.test(tipo))? numero.substr(0,3) : numero);
	} else {
		campos[tipo] = "";
	}
};
const espacios = tipo => (value, campos) => {
	campos[tipo] = (value != undefined)? value.replace(" ","") : "";
};
const validate = (campos) => {
	const errors = {};

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email =  campos.email.replace(" ","");
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "El correo electrónico no es válido. Favor de verificar.";
		}
	}

	if (!campos.email_confirm) {
		errors.email_confirm = "Campo requerido.";
	} else {
		campos.email_confirm =  campos.email_confirm.replace(" ","");
		if (campos.email && campos.email_confirm && (campos.email != campos.email_confirm)) {
			errors.email_confirm = "El correo electrónico no coincide. Favor de verificar.";
		}
	}

	if(!campos.telefono_movil) {
		errors.telefono_movil = "Campo requerido.";
	} else if (!campos.lada_movil && campos.telefono_movil) {
		errors.telefono_movil = "Campo Lada requerido.";
	} else if (campos.lada_movil && campos.telefono_movil && ((campos.lada_movil.length + campos.telefono_movil.length) -1) != 10) {
		errors.telefono_movil = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if(campos.lada_fijo && !campos.telefono_fijo) {
		errors.telefono_fijo = "Campo requerido.";
	}
	if(!campos.lada_fijo && campos.telefono_fijo) {
		errors.telefono_fijo = "Campo Lada fijo requerido.";
	} else if (campos.lada_fijo && campos.telefono_fijo && ((campos.lada_fijo.length + campos.telefono_fijo.length) -1) != 10) {
		errors.telefono_fijo = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	} else if(campos.lada_movil && campos.telefono_movil && campos.lada_fijo && campos.telefono_fijo) {
		let celular = campos.lada_movil + campos.telefono_movil;
		let telefono = campos.lada_fijo + campos.telefono_fijo;
		if(celular == telefono) {
			errors.telefono_fijo = "Tu número de teléfono debe ser diferente.";
		}
	}

	if(campos.lada_fijo == "+" && campos.telefono_fijo == ""){
		delete errors.telefono_fijo;
	} else if(campos.lada_fijo == "+" && !campos.telefono_fijo){
		delete errors.telefono_fijo;
	}

	if (!campos.fecha_nacimiento || campos.fecha_nacimiento == " ") {
		errors.fecha_nacimiento = "Campo requerido.";
	}

	if (!campos.nombres) {
		errors.nombres = "Campo requerido.";
	}

	if (!campos.apaterno) {
		errors.apaterno = "Campo requerido.";
	}

	if (!campos.amaterno) {
		errors.amaterno = "Campo requerido.";
	}

	if(!campos.rfc) {
		errors.rfc = "Campo requerido.";
	} else if(/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(campos.rfc) == false) {
		errors.rfc = "Formato de RFC inválido.";
	} else if(campos.rfc && campos.dia && campos.mes && campos.anio) {
		if(campos.rfc.substr("4","6") != campos.anio.substr("2","2") + campos.mes + campos.dia) {
			errors.rfc = "El RFC no concuerda con la fecha de nacimiento.";
		}
	}	
	
	return errors;
};

const renderField = ({ input, label, type, cerrar, max, meta: { touched, error, warning } }) => {
	let errorClass = classNames({"error-wrap": true, "hidden": hideErrors[input.name]});
	return (
		<div>
			<input {...input} type={type} maxLength={max} />
			{touched && (error &&
				<div className={errorClass}>
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

const renderFieldDate =  ({ input, type, onChange, cerrar, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} className="datepicker-input input-group date" />
			{touched && (error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class Datos extends React.Component {

	focus = (e) => {
		hideErrors[e.target.name] = false;
	}

	cerrar = (e) => {
		hideErrors[e] = true;
		let value = document.querySelector("input[name="+e+"]").value == ""? " " : "";
		this.props.change(e, value);
	}

	componentWillMount = () => {
		var _this = this;
		$(function () {
			$("input.datepicker-input").datepicker({
				format: "dd   -   MM   -   yyyy",
				language: "es",
				startDate: "-120y",
				endDate: "-16y",
				autoclose: true,
				disableTouchKeyboard: true
			}).on("changeDate", _this.handleDateChangeEvent);

			$("input[name=email], input[name=email_confirm]").bind("copy paste",function(e) { e.preventDefault(); return false; });
		});
	}

	handleDateChangeEvent = (ev) => {
		this.props.change("fecha_nacimiento", ev.format());
		this.props.change("fecha_nacimiento_date", ev.date.getTime());
	}

	render () {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="text-content mt-34">
					<div className="datos-wrap row">
						<div className="col-md-6 col-xs-12">
							<h5><i><img src={ require("../img/icon_user.png") } alt="" /></i>Datos Personales</h5>
							<div className="row mt-25">
								<div className="col-xs-12">
									<div className="input-wrap">
										<label>Correo electrónico</label>
										<span className="input-active">
											<Field name="email" component={renderField} cerrar={this.cerrar.bind(this,"email")} onFocus={this.focus.bind(this)} type="text" validate={espacios("email")} max="50" />
										</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="input-wrap">
										<label>Confirmar correo electrónico</label>
										<span className="input-active">
											<Field name="email_confirm" component={renderField} cerrar={this.cerrar.bind(this,"email_confirm")} onFocus={this.focus.bind(this)} type="text" validate={espacios("email_confirm")} max="50" />
										</span>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="input-wrap">
										<label>Fecha de nacimiento</label>
										<span className="clearfix input-active">
											<Field name="fecha_nacimiento" type="text" component={renderFieldDate} />
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-xs-12">
							<h5>
								<i><img src={require("../img/icon_cellphone.png")} alt="" /></i>Teléfono celular
								<span className="orange-tooltip">
									<button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-celular" >?</button>
								</span>
							</h5>
							<div className="row mt-25">
								<div className="col-xs-12">
									<div className="row">
										<div className="col-xs-4">
											<div className="input-wrap">
												<label>Lada</label>
												<span className="clearfix input-active">
													<Field name="lada_movil" component={renderField} type="text" max="4" validate={telefono("lada_movil")} />
												</span>
											</div>
										</div>
										<div className="col-xs-8">
											<div className="input-wrap">
												<label>Teléfono</label>
												<span className="clearfix input-active">
													<Field name="telefono_movil" component={renderField} type="text" max="8" validate={telefono("telefono_movil")} />
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 mt-34">
									<h5><i><img src={require("../img/icon_phone.png")} alt="" /></i>Teléfono fijo (Opcional)</h5>
								</div>
								<div  className="col-xs-12 mt-20">
									<div className="row">
										<div className="col-xs-4">
											<div className="input-wrap">
												<label>Lada</label>
												<span className="clearfix">
													<Field name="lada_fijo" component={renderField} type="text" max="4" cerrar={this.cerrar.bind(this,"lada_fijo")} onFocus={this.focus.bind(this)} validate={telefono("lada_fijo")} />
												</span>
											</div>
										</div>
										<div className="col-xs-8">
											<div className="input-wrap">
												<label>Teléfono</label>
												<span className="clearfix">
													<Field name="telefono_fijo" component={renderField} type="text" max="8" cerrar={this.cerrar.bind(this,"telefono_fijo")} onFocus={this.focus.bind(this)} validate={telefono("telefono_fijo")} />
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{ this.props.grupo && (this.props.ramo == "A" || this.props.ramo == "V") &&
							<div className="col-md-6 col-xs-12">
								<h5>
									<i><img src={ require("../img/icon_user.png") } /></i>{ (this.props.ramo == "A")?"Conductor Habitual":"Datos Adicionales" }
								</h5>
								{ this.props.ramo == "A" &&
									<div className="row mt-25">
										<div className="col-xs-12">
											<div className="input-wrap">
												<label>Apellido Paterno</label>
												<span className="clearfix input-active">
													<Field name="apaterno" type="text" component={renderField} />
												</span>
											</div>
										</div>
										<div className="col-xs-12">
											<div className="input-wrap">
												<label>Apellido Materno</label>
												<span className="clearfix input-active">
													<Field name="amaterno" type="text" component={renderField} />
												</span>
											</div>
										</div>
										<div className="col-xs-12">
											<div className="input-wrap">
												<label>Nombre(s)</label>
												<span className="clearfix input-active">
													<Field name="nombres" type="text" component={renderField} />
												</span>
											</div>
										</div>
									</div>
								}
								{ this.props.ramo == "V" &&
									<div className="row mt-25">
										<div className="col-md-6 col-xs-12">
											<div className="input-wrap">
												<label>RFC</label>
												<span className="clearfix input-active">
													<Field name="rfc" max="13" type="text" component={renderField} />
												</span>
											</div>
										</div>
									</div>
								}
							</div>
						}
					</div>
					<button className="orange-rectangle" type="submit" disabled={submitting}>Siguiente</button>
				</div>

				<Field name="fecha_nacimiento_date" component={renderField} type="hidden" />

				<div className="modal fade" id="modal-celular" tabIndex="-1" role="dialog" aria-labelledby="modal-celularLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title orange-text" id="modal-celularLabel">Establecer teléfono de contacto</h4>
							</div>
							<div className="modal-body">
								<p>El teléfono celular será utilizado como medio de contacto para notificarte operaciones realizadas o enviarte códigos de verificación requeridos en algunas transacciones.</p>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

Datos = reduxForm({form: "registro-datos", validate})(Datos);

export default connect(mapState, null)(Datos);



// WEBPACK FOOTER //
// ./src/registro/datos.frm.js